/**
 * Helpers for the catalog category tree (#111877 — in-page mobile category picker).
 */

/**
 * Find a category's name anywhere in the tree (walks children recursively).
 * Returns `fallback` when the id is null/absent — e.g. before the tree has
 * loaded, or while a search is showing a server-rendered title.
 */
function findCategoryName(categories, id, fallback = "") {
    if (id == null || !Array.isArray(categories)) {
        return fallback;
    }

    for (const category of categories) {
        if (category.id === id) {
            return category.name;
        }
        const childMatch = findCategoryName(category.children || [], id, null);
        if (childMatch !== null) {
            return childMatch;
        }
    }

    return fallback;
}

module.exports = { findCategoryName };
